import React, { useState, useEffect,useCallback  } from 'react';
import Drawer from '@mui/material/Drawer';
import { Slide } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import LightModeIcon from '@mui/icons-material/LightMode';
import ModeNightIcon from '@mui/icons-material/ModeNight';
import { useLocation } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';


function Popup({ activeTheme, font, clientName, language, selectedLayout, carbon, rating,grandTotal}) {
  const [data, setData] = useState(null);
  const [DrawerOpen, setDrawerOpen] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [selectedPopup, setSelectedPopup] = useState({});
  //const [showInitialDrawer, setShowInitialDrawer] = useState(true);
  const [darkMode, setDarkMode] = useState(false);
  const [invoiceTemplate, setInvoiceTemplate] = useState('');
  const [apiHtml, setApiHtml] = useState('');
  const [showNotifications, setShowNotifications] = useState(false);
  const toggleNotification = () => { setShowNotifications(!showNotifications); };
  const [showBellBtn, setshowBellBtn] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
   //const [selectedDevice, setSelectedDevice] = useState("desktop");
  //const toggleDevice = () => {setIsMobile((prev) => !prev); };

  useEffect(() => {
    const timer = setTimeout(() => { 
      setshowBellBtn(true);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        let response;
        if (clientName) {
          response = await fetch(`/invoice/client/${clientName}/content/${language}/notification.json`);
        } else {
          response = await fetch(`/json/notification-${language}.json`);
        }
        const updatedNotifications = await response.json();
        setNotifications(updatedNotifications);
      } catch (error) {
        console.error('Error fetching notifications:', error);
      }
    };
    fetchNotifications();
  }, [language, clientName]);

  const removeNotification = (id) => {
    setNotifications(notifications.filter((notification) => notification.id !== id));
  };

  const { search } = useLocation();
  const params = new URLSearchParams(search);
  //const demoIncludedThemes = params.get('included');

  useEffect(() => {
    const fetchData = async () => {
      try {
        let response;
        if (clientName) {
          response = await fetch(`/invoice/client/${clientName}/content/${language}/popup.json`);
        } else {
          response = await fetch(`/json/popup-${language}.json`);
        }
        const data = await response.json();
        setData(data);
      } catch (error) {
        console.error('Error fetching json data:', error);
      }
    };
    fetchData();
  }, [language, clientName]);

  const toggleDrawer = () => {
    setDrawerOpen(!DrawerOpen);
    if (!DrawerOpen) {
      document.body.classList.add('drawer-opened');
    } else {
      document.body.classList.remove('drawer-opened');
    }
  };

  useEffect(() => {
    if (notifications.length === 0) {
      setShowNotifications(false);
    }
  }, [notifications]);

  const openPopup = (popup) => {
    setSelectedPopup(popup);
    setPopupOpen(true);
  };

  const closePopup = (event) => {
    event.preventDefault();
    setPopupOpen(false);
  };

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
    document.body.classList.toggle('dark-mode', !darkMode);
  };

  useEffect(() => {
    const modeSuffix = darkMode ? 'dark' : 'light';
    const templateURL = clientName
      ? `/template/${language}/${activeTheme}/${modeSuffix}/aa/${selectedLayout}/${font}/${clientName}?carbon=${carbon}&rating=${rating}`
      : `/template/${language}/${activeTheme}/${modeSuffix}/aaaa/${selectedLayout}/${font}/${clientName}?carbon=${carbon}&rating=${rating}`;

    setInvoiceTemplate(templateURL);
  }, [activeTheme, font, darkMode, language, selectedLayout, clientName, carbon, rating]);

const fetchApiHtml = useCallback(async () => {
  try {
    const response = await fetch(invoiceTemplate);
    const data = await response.text();
    setApiHtml(data);
  } catch (error) {
    console.error('Error fetching API data:', error);
  }
}, [invoiceTemplate]);

  const [popupHtml, setPopupHtml] = useState('');
  const fetchedContentHtml = async (filePath) => {
    try {
      const response = await fetch(filePath);
      if (!response.ok) {
        throw new Error(`Failed to load ${filePath}`);
      }
      return await response.text();
    } catch (error) {
      //console.error('Error fetching HTML:', error);
      // return '<div>Error loading content</div>';
    }
  };

  useEffect(() => {
    if (selectedPopup.contentHTML) {
      fetchedContentHtml(selectedPopup.contentHTML).then(setPopupHtml);
    }
  }, [selectedPopup.contentHTML]);

  useEffect(() => {
    if (data && data.popups) {
      const pageLoadPopup = data.popups.find((popup) => popup.displayOnPageLoad === 'yes');
      if (pageLoadPopup) {
        setSelectedPopup(pageLoadPopup);
        setPopupOpen(true);
      }

      if (true) {
        // Check if you want to enable the timer
        const enableTimer = true;
        if (enableTimer) {
          // Start a timer to close the drawer after 5 seconds
          const timer = setTimeout(() => {
            setDrawerOpen(false);
          }, 1000);

          // Clear the timer if the user manually closes the drawer
          return () => clearTimeout(timer);
        } else {
          // If no timer is enabled, close the drawer
          setDrawerOpen(true);
        }
      }
    }
    fetchApiHtml();
  }, [data, fetchApiHtml]);

  return (
    <>
      <div className="bg-dark mobile-menu">
        <div style={{ padding: '0.25em', justifyContent: 'xbetween' }} className="d-flex align-items-center justify-content-between invoice-wrap">
          <div className="text-white h6 fw-normal ">Invoice #852352</div>
          <div className='flex-center'>
          <span
            onClick={toggleNotification}
            className={`bg-theme-primary box-button me-2 notification ${showBellBtn ? '' : 'bell-btn-move'}`}
            aria-label="menu"
            style={notifications.length === 0 ? { pointerEvents: 'none', marginTop: '-85px' } : {}}
          >
            <NotificationsActiveIcon />
            {notifications.length > 0 && <span>{notifications.length}</span>}
          </span>
            <b style={{ color: 'gray' }} className="me-1 mobile-menu-label d-none">
              Menu{' '}
            </b>
            <span onClick={toggleDrawer} className="bg-theme-primary box-button">
              <MenuIcon />
            </span>
            <span className="d-none box-button ms-1 theme-primary" onClick={toggleDarkMode}>
              {darkMode ? <LightModeIcon /> : <ModeNightIcon />}
            </span>
          </div>
        </div>
      </div>
      {data && data.menuPanelCSS && <style dangerouslySetInnerHTML={{ __html: data.menuPanelCSS }}></style>}
      <div className="font-arial">
        <span onClick={toggleDrawer} className="bg-theme-primary box-button" aria-label="menu" id="burger-menu">
          <MenuIcon />
        </span>
        <span
          onClick={toggleNotification}
          className={`bg-theme-primary box-button notification ${showBellBtn ? '' : 'bell-btn-move'}`}
          aria-label="menu"
          id="burger-menu"
          style={notifications.length === 0 ? { pointerEvents: 'none', marginTop: '-85px' } : {}}
        >
          <NotificationsActiveIcon />
          {notifications.length > 0 && <span>{notifications.length}</span>}
        </span>

        {showNotifications && (
          <div className="notification-container font-secondary">
            <div className="bg-white rounded shadow notification-messages">
              <div className="flex-center bg-dark bg-theme-secondary p-1 text-white w-100 notif-header" style={{ justifyContent: 'space-between', padding: '1em 2em' }}>
                <h6 className="font-primary m-0 p-1 p-2 text-white fw-bold">{language === 'arabic' ? 'الإشعارات الحديثة' : 'Recent Notifications'}</h6>
                <div onClick={toggleNotification} className="m-0 p-0 text-white h4 mx-3" style={{ cursor: 'pointer' }}>
                  <CloseIcon />
                </div>
              </div>

              <ul className="m-0 p-0">
                {notifications.map((notification, index) => (
                  <>
                    <li key={notification.id} className="lh-2 Xtext-nowrap fw-normal Xbg-theme-accent-verylight hover-bg-primary-verylight d-flex align-items-center justify-content-between pe-2 pt-2 pb-2" style={{lineHeight:'1.5'}}>
                    <span style={{ display:'inline-block',height: '60px', minWidth: '60px', width: '60px', overflow: 'hidden', backgroundImage: `url("${notification.imageUrl}")`, backgroundPosition: 'center', marginRight: '10px', marginLeft: '10px',backgroundSize:'cover'}}></span>
                    <span className='flex-grow-1 text-start'>{notification.text}{' '}
                      <a href={notification.linkHref} className="fw-bold link-primary d-inline-block text-nowrap" target='_blank' rel="noopener noreferrer">
                        {notification.linkText}
                      </a>
                    </span>
                    
                      
                      <button
                        className="rounded rounded-pill"
                        onClick={() => removeNotification(notification.id)}
                        style={{ lineHeight: '1', marginLeft: '0', background: 'none', border: 'none', cursor: 'pointer' }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          viewBox="0 0 24 24"
                          style={{ fill: 'red', stroke: 'red', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' }}
                        >
                          <path d="M18 6L6 18M6 6l12 12" />
                        </svg>
                      </button>
                    </li>
                    {index !== notifications.length - 1 && <hr className="m-0 opacity-25" />}
                  </>
                ))}
              </ul>
            </div>
          </div>
        )}
        <Drawer anchor="right" open={DrawerOpen} onClose={toggleDrawer} hideBackdrop TransitionComponent={Slide} transitionDuration={{ enter: 400, exit: 200 }}>
          <div className={`drawer-wrap ${language === 'arabic' ? 'arabic' : ''}`} dir={language === 'arabic' ? 'rtl' : ''}>
            <div>
              <div id="burger-close" className="flex-center" style={{ justifyContent: 'space-between', padding: '7px', width: '100%', alignItems: 'start' }}>
                <div className="bg-theme-primary box-button" onClick={toggleDarkMode}>
                  {darkMode ? <LightModeIcon /> : <ModeNightIcon />}
                </div>
                <div onClick={toggleDrawer} className="bg-theme-primary box-button" aria-label="menu" id="">
                  <CloseIcon />
                </div>
              </div>
            </div>
            <div style={{ minWidth: '150px' }} className="drawer-wrap">
              <div className="drawer-box">
                {data &&
                  data.popups &&
                  data.popups.map((popup, index) => {
                    let widgetClassName = '';
                    if (!popup.displayDevice.includes('mobile')) widgetClassName += ' mob-hide';
                    if (!popup.displayDevice.includes('tablet')) widgetClassName += ' tab-hide';
                    if (!popup.displayDevice.includes('desktop')) widgetClassName += ' des-hide';

                    const isExternalLink = popup.externalLink && popup.externalLink.trim() !== '';
                    const isPDFFile = isExternalLink && popup.externalLink.toLowerCase().endsWith('.pdf');

                    return (
                      popup.displayStatus === 'active' &&
                      popup.showInMenu === 'yes' && (
                        <a
                          key={index}
                          className={`button ${widgetClassName}`}
                          {...(isExternalLink
                            ? isPDFFile
                              ? {
                                  href: popup.externalLink,
                                  target: '_blank',
                                  ...(popup.externalType === 'download' ? { download: '' } : {})
                                }
                              : { href: popup.externalLink, target: '_blank', rel: 'noopener noreferrer' }
                            : { onClick: () => openPopup(popup) })}
                        >
                          {popup.iconSVGCode && <span dangerouslySetInnerHTML={{ __html: popup.iconSVGCode }}></span>}
                          <span>{popup.menuLabel}</span>
                        </a>
                      )
                    );
                  })}
                {language === 'arabic' ? <link rel="stylesheet" type="text/css" href="/root-css/arabic-font.css" /> : ''}
              </div>
            </div>
          </div>
        </Drawer>

        <Dialog id="mypopup" open={popupOpen}  onClose={closePopup} disableAutoFocus disableEnforceFocus aria-labelledby="popup-title" dir={language === 'arabic' ? 'rtl' : ''}>
          <style dangerouslySetInnerHTML={{ __html: selectedPopup.iframeHTML }} style={{ overflow: 'hidden' }} />
          <h2 id="popup-title" className="flex-center">
            <span style={{ paddingRight: '1em' }}>{selectedPopup.title}</span>
            <button
              onClick={closePopup}
              aria-label="close"
              className="d-inline-block cursor-pointer line-height-normal"
              style={{ background: "none", border: "none" }}
            >
              <CloseIcon style={{ color: 'white' }} />
            </button>
          </h2>
          <div className="popup-body h-100">            
            {selectedPopup.iframeHTML && <div className="t-c"  dangerouslySetInnerHTML={{ __html: selectedPopup.iframeHTML }} style={{ overflow: 'hidden' }} />}
            {selectedPopup.contentCSS && <style dangerouslySetInnerHTML={{ __html: selectedPopup.contentCSS }} />}
            {selectedPopup.contentHTML && <div className="h-100" dangerouslySetInnerHTML={{ __html: popupHtml }} />}
            {selectedPopup.function &&               
            <div className='p-2 bg-theme-primary-verylight'>
                        <div className="">
                              <div className="row mb-0 p-0 m-0 align-items-stretch">
                                <div className="col-md-6 m-0 d-flex p-0 pe-md-2">
                                  <div className="bg-theme-accent text-dark rounded p-2 d-flex flex-fill flex-center">
                                    <div>
                                      <p className="p-0 mb-1 fw-semibold text-center">Amount to pay:</p>
                                    <p className="p-0 fs-4 fw-bold mb-0 text-center">£ {grandTotal.toFixed(2)}</p></div>
                                    
                                  </div>
                                </div>
                                <div className="col-md-6 my-2 my-md-0 p-0">
                                  <div className="bg-theme-accent rounded p-2 text-center w-100 d-flex flex-column flex-fill">
                                    <div className="d-flex d-md-block align-items-center justify-content-center">                                      
                                      <img src="/img/qr.png" alt="QR code" className="img-fluid rounded" />
                                      <div className="mt-0 mt-md-2 text-dark fw-semibold ms-2 ms-md-0">Scan to pay</div>
                                    </div>
                                  </div>
                                </div> 
                              </div>
                              <div className="d-flex align-items-center mt-3 small justify-content-center">
                                <span className="me-1 fs-5 lh-1">ℹ️</span>
                                <span className='lh-1'>You will be redirected to the payment page of Stripe.</span>
                              </div>
                              <hr />
                              <div className="mb-3 mt-1">
                                <div className="small mb-2">Supported payment methods:</div>
                                <div className="d-flex align-items-center gap-2 flex-wrap">
                                  <img src="/img/payment.png" alt="VISA" />
                                </div>
                              </div>

                              <button className="w-100 d-block btn">
                                Make Payment
                              </button>
                        </div>

              </div>}
          </div>
        </Dialog>
        <style>
          {`
            #mypopup .MuiDialog-container .MuiPaper-root{ 
                @media screen and (min-width: 968px){
                    min-width: ${selectedPopup.width ? selectedPopup.width + 'px!important;' : 'auto;'};
                }       
                height: ${selectedPopup.height ? Number(selectedPopup.height) + 55 + 'px!important;' : 'auto;'};
            }
            `}
        </style>
      </div>
    </>
  );
}

export default Popup;

/* 
toggle - mobile -desktop icon
<div onClick={toggleDevice} className={`bg-theme-primary box-button`} aria-label="toggle-device">
              {isMobile ? <DesktopWindowsIcon /> : <PhoneIphoneIcon />}
            </div> 
*/